import { config } from "@/Common/envConfig";

export const addCookiePro = () => {
  // TODO: set if the environment is dev or qa and not charge. Leave this, is for qa purposes.
  const newScript = document.createElement("script");
  newScript.setAttribute("src", "https://cookie-cdn.cookiepro.com/scripttemplates/otSDKStub.js");
  newScript.setAttribute("data-document-language", "true");
  newScript.setAttribute("type", "text/javascript");
  newScript.setAttribute("charset", "UTF-8");
  newScript.setAttribute("sandbox", "allow-same-origin allow-scripts allow-popups allow-forms");
  newScript.setAttribute(
    "data-domain-script",
    `55b6c085-9148-44c8-839b-c464e21cd6f8${config.testCookies ? "-test" : ""}`
  );
  document.body.appendChild(newScript);
};
